import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import LinearProgress from 'material-ui/LinearProgress';
import moment from 'moment';
import React from 'react';
import { Redirect } from 'react-router';
import { axiosCallService } from '../common/apiCallService';
import { saveActivity, trackSid } from "../common/commonService";
import AuthenticateUser from './AuthenticateUser.js';
import queryString from 'query-string';
import { DispatcherFunction } from 'mygame-components';

export default class LoginWithClient extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      location: '/',
      msg: "",
      open: false,
      userRedirect: '',
      skipLogin: false,
      fromClient:JSON.parse(localStorage.getItem('fromClient',false))
    }
    if (Object.keys(props).length > 0) {
      if (props.location.search)
        this.receiveMessage()
    }
  }

  checkLastHandsDtls = async () => {
    try {
      let location = '/',
        access = JSON.parse(localStorage.getItem('userRole'));
      if(this.state.fromClient)
        localStorage.setItem('pathName','/');
      if (localStorage.getItem('pathName') && localStorage.getItem('pathName') != null && localStorage.getItem('pathName') != '/') {
        location = localStorage.getItem('pathName')
      } else if (JSON.parse(localStorage.getItem('userRole')).includes('PLAYER')) {
        let playerData = await axiosCallService(`/reportCard/getLast48HrsDtls`, {
          accountName: localStorage.getItem('accountName'), gameType: ['cash', 'tournament', 'Spin'],
          gameSubType: ['Texas Holdem', 'Omaha Hi'],
          ringType: ['6-seater', 'Full Ring', 'Head-up']
        });
        // if (playerData.data.isMygameLanding) {
        //   location = `/home?${queryString.stringify({
        //     gameType: playerData.data.gameType,
        //     dateRange: playerData.data.dateRange,
        //     ringType: playerData.data.ringType,
        //     gameSubType: playerData.data.gameSubType,
        //     totalHandPlayed: playerData.data.totalHandPlayed
        //   })}`
        // } else if (!playerData.data.isMygameLanding) {
        //   if (playerData.data.singleReport)
        //     location = `/ReportCard/${localStorage.getItem('accountName')}/${playerData.data.gameType}?${queryString.stringify({
        //       hitLevel: 'All Level',
        //       hitRange: playerData.data.dateRange,
        //       hitType: playerData.data.ringType
        //     })}`
        //   else
        //     location = '/SkillLevel?logintype=player'
        // }
        let gameType = "cash", gameSubType = "NLH", ringType = "6-seater", dateRange = "Today", totalHandPlayed = 0
        if (!((['spin', 'plo'].includes((playerData.data.gameType).toLowerCase())) || playerData.data.gameType === 'Omaha Hi')) {
          gameType = playerData.data.gameType
          gameSubType = playerData.data.gameSubType
          ringType = playerData.data.ringType
          dateRange = playerData.data.dateRange
          totalHandPlayed = playerData.data.totalHandPlayed
        }
    location = `/home?${queryString.stringify({ gameType, gameSubType, ringType, dateRange, totalHandPlayed })}`
        saveActivity({
          hit_page: 'LoginWithClient',
          hit_type: 'LoginSuccess_Test',
          hit_attribute2: location,
        })
        this.setState({ userRedirect: location })
      } else {
        if (access.indexOf('SHIFT_MANAGER') !== -1 || access.indexOf('COACH') !== -1 || access.indexOf('SYS_ADMIN') != -1 || access.indexOf('BUSINESS_OWNER') != -1) {
          location = '/pokerwatch'
        }

      }
      return location
    } catch (err) {
      console.log("ERROR IN BLOCK:::checkLastHandsDtls", JSON.stringify(err))
      throw err;
    }
  }

  setLocation = async () => {
    try {
      let searchParams = queryString.parse(this.props.location.search)
      if ((localStorage.getItem('pathName') === "/liveview") || (this.props.location.search && searchParams.redirectUri && searchParams.redirectUri === "liveview")) {
        // this.setState({ userRedirect: '/liveview' })
        saveActivity({
          hit_page: 'LoginWithClient',
          hit_type: 'setLocation Test',
          hit_attribute2: '/liveview',
        })
        return '/liveview'
      } else if (localStorage.getItem('pathName') && localStorage.getItem('pathName').includes("/liveview")) {
        saveActivity({
          hit_page: 'LoginWithClient',
          hit_type: 'setLocation Test',
          hit_attribute2: localStorage.getItem("pathName"),
        })
        return localStorage.getItem("pathName")
      } else {
        saveActivity({
          hit_page: 'LoginWithClient',
          hit_type: 'setLocation Test',
          hit_attribute2: 'Other Locations',
        })
        const location = await this.checkLastHandsDtls()
        console.log("location:", location, "this.state.userRedirect:", this.state.userRedirect, "return this.state.userRedirect")
        return location
      }
    } catch (error) {
      saveActivity({
        hit_page: 'LoginWithClient',
        hit_type: 'setLocation Test',
        hit_attribute2: "function expection",
      })
      console.log("ERROR IN BLOCK:::checkLastHandsDtls", JSON.stringify(error))
      throw new Error(error);
    }
  }

  receiveMessage = () => {
    this.setState({ loading: true, skipLogin: false })
    AuthenticateUser.geoInfo()
      .then(() => {
        let searchParams = queryString.parse(this.props.location.search)
        if ((searchParams.partnerToken && searchParams.partnerToken !== ""
          && searchParams.accountId && searchParams.accountId !== "") 
          || (searchParams.code && searchParams.code!="" && searchParams.scope && searchParams.scope!="")
          || (searchParams.assertionId && searchParams.assertionId !="")
          || (searchParams.code && searchParams.code!="" && searchParams.state && searchParams.state!="")
          ) {
          return AuthenticateUser.validateClientPlayerToken(searchParams)
        } else {
          console.log("Loging Failed accountId or partnerToken missing!")
          if (searchParams.redirectUri === "liveview") {
            let pathname = "/liveview" +
              (searchParams.openingTab ? `?openingTab=${searchParams.openingTab}` : "") +
              (searchParams.sId ? `${searchParams.openingTab ? "&" : "?"}sId=${searchParams.sId}` : "")
            localStorage.setItem("pathName", pathname)
          }
            this.setState({
              skipLogin: true,
              location: '/'
            }, () => {
              return {}
            })
        }
      })
      .then(async (data) => {
        if (!this.state.skipLogin) {
          if (data.success) {
            return await this.setLocation()
          } else {
            saveActivity({
              hit_page: 'LoginWithClient',
              hit_type: 'LoginFailed_Test',
              hit_attribute1: JSON.stringify(data),
              hit_attribute2: "receiveMessage_Sucess_Block",
            })
            this.setState({ msg: data.responseJSON && data.responseJSON.msg ? data.responseJSON.msg : "Something went wrong...Please try again " })
            this.setState({ open: true })
          }
        } else {
          return '/';
        }
      })
      .then((redirectURI) => {
        if (!this.state.skipLogin) {
          console.log(redirectURI, "redirectURI......")
          let searchParams = queryString.parse(this.props.location.search),
            userRedirect = this.state.userRedirect
          let url = ""
          console.log("searchParams", searchParams);

          let track = {};
          track.userid = localStorage.getItem("username")
          track.hit_timestamp = moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ')
          track.session_id = localStorage.getItem("token")
          track.userid = localStorage.getItem("username")
          track.deviceInfo = JSON.parse(localStorage.getItem("deviceInfo"))
          track.hit_page = 'LoginWithClient'
          track.hit_type = 'LoginSuccess_ApiTrack'
          track.hit_attribute1 = JSON.stringify(queryString.parse(this.props.location.search))
          track.hit_attribute2 = localStorage.getItem('pathName')
          track.hit_attribute3 = (localStorage.getItem('pathName') === "/liveview") || (searchParams.redirectUri && searchParams.redirectUri === "liveview")

          if ((localStorage.getItem('pathName') === "/liveview") || (searchParams.redirectUri && searchParams.redirectUri === "liveview")) {
            if (searchParams.openingTab) {
              url = "/liveview?openingTab=" + searchParams.openingTab;
            } else {
              url = "/liveview"
            }
            userRedirect = "/liveview";
            track.hit_attribute5 = `https://${window.location.hostname}${url}`
          } else if (localStorage.getItem('pathName') && localStorage.getItem("pathName").includes("liveview")) {
            url = localStorage.getItem("pathName")
            userRedirect = "/liveview";
            track.hit_attribute5 = `https://${window.location.hostname}${url}`
          }

          saveActivity(track)
          const params = queryString.parse(this.props.location.search);
          console.log("params, params.sId", params, params.sId)
          if (params && params.sId) {
            trackSid(params.sId, window.location.pathname)
          }
          saveActivity({
            hit_page: 'LoginWithClient',
            hit_type: 'LoginSuccess',
            hit_attribute1: userRedirect,
            hit_attribute2: "receiveMessage_LoginSuccess_Block",
          })
          if (userRedirect === "/liveview") {
            window.location = "https://" + window.location.hostname + url
          } else {
            this.setState({ loginRedirect: AuthenticateUser.isAuthenticated, location: redirectURI, loading: false })
          }
        } else {
          console.log("pathName:::::>>>", localStorage.getItem("pathName"))
          console.log("window.location.hostname:::::>>>", window.location.hostname)
          this.setState({loginRedirect: true, loading: false})
        } 
      })
      .catch((err) => {
        console.log("err", err)
        saveActivity({
          hit_page: 'LoginWithClient',
          hit_type: 'LoginFailed',
          hit_attribute1: (typeof err === 'object' ? JSON.stringify(err) : err),
          hit_attribute2: "receiveMessage_Error_Block",
        })
        this.setState({ msg: err.responseJSON && err.responseJSON.msg ? err.responseJSON.msg : "Something went wrong...Please try again " })
        this.setState({ open: true })
      })
  }



  handleOpen = () => {
    this.setState({ open: true });
  }

  handleClose = () => {
    this.setState({
      loginRedirect: true,
      location: '/',
      open: false
    })
  }

  render() {
    console.log('loginRedirect', this.state.loginRedirect, this.state.location)
    const actions = [<FlatButton label="Ok" primary={true} keyboardFocused={true} onClick={this.handleClose} />]
    // const actions2 = [<FlatButton label="Continue" primary={true} keyboardFocused={true} onClick={() => {
    //   window.open('https://' + window.location.hostname + '/liveview','_blank', 'location=yes,height=670,width=400,scrollbars=yes,status=yes');
    //   var myWindow = window.open("", "_self");
    //   myWindow.close()
    // }}/>,<FlatButton label="Close" primary={false} keyboardFocused={false} onClick={()=>{window.close()}}/>]
    return (
      <div className="app-content-loading" style={{ backgroundColor: '#2D2C34' }}>
        <center>
          <img id="loadingImg" src={require('../img/login-logo.png')} style={{ width: '30%', marginTop: '10%' }} alt="Loading..." />
          <LinearProgress mode="indeterminate" color='#DE460F' style={{ width: '40%' }} />
        </center>
        {!this.state.fromClient && <Dialog actions={actions} modal={false} open={this.state.open} onRequestClose={this.handleClose}>{this.state.msg} </Dialog>}
        {/* <Dialog actions={actions2} modal={false} open={this.state.isOpen} onRequestClose={this.handleConfirmClose}>Pop-up is blocked for this domain do you want to Continue?</Dialog> */}
        {(this.state.loginRedirect && (this.state.skipLogin || localStorage.getItem('pathName') !== "/liveview"))? (<Redirect to={this.state.location} />):''}
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/LoginWithClient.js
 **/